import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { getHistoricalData } from "@/_core/data/api_calls/candle_data/getHistoricalData";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves forward and volatility data for commodities
 * @param {object} ctx: context variables, must include ctx.currencyNumber and ctx.initCurrencyDate
 */
export function getFWDVolCurrencies(ctx) {
  const variables = {
    currency: ctx.currencyNumber,
    format: "json",
    observation_date: formatDate_YMD(
      new Date(new Date().setFullYear(new Date().getFullYear() - 5))
    )
  };
  return getHistoricalData(ctx, {
    fetch: gatewayService.currencies.ohlcFwdVolRr,
    variables,
    source: "currency_ohlc_fwd_vol_rr"
  });
}
